import AriaAct from "@resources/aria-act/AriaAct";

document.addEventListener('DOMContentLoaded', function() {
	const classToObserve = 'atonal-short-bios-item__head'
	AriaAct.registerListener('click',`.${classToObserve}`,'expandToggle')
	window.addEventListener("AriaAct:expandOpen", (e) => {
		if( !e.detail.trigger.classList.contains(classToObserve) ) return;
		AriaAct.closeOthersOnOpen(e.detail)
	});
});
